export enum EAggFunction {
    sum = 'sum',
    min = 'min',
    max = 'max',
    avg = 'avg'
}
